import { render } from "./JzList.vue?vue&type=template&id=8e78e3f4&scoped=true"
import script from "./JzList.vue?vue&type=script&lang=js"
export * from "./JzList.vue?vue&type=script&lang=js"

import "./JzList.vue?vue&type=style&index=0&id=8e78e3f4&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e78e3f4"]])

export default __exports__